export default "__VITE_ASSET__CE5W8ErK__"